import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceAction } from '../enums/invoice-action.enum';
import { InvoiceRepository } from '../interfaces/invoice-repository.interface';

@Injectable()
export class ExecuteInvoiceActionUseCase {
  constructor(private readonly repository: InvoiceRepository) {}

  execute(invoiceId: number | string, action: InvoiceAction, serviceInvoiceId:  (number | string)): Observable<void | Blob> {
    return this.repository.executeAction(invoiceId, action, serviceInvoiceId);
  }
}
